import {iframeAppBiLoggerFactory} from '@wix/iframe-app-bi-logger';
import * as Wix from 'wix-sdk'; // eslint-disable-line import/no-unresolved

interface ErrorEventParams {
  errn: string;
  errc: number;
  p1?: any;
  p2?: any;
  p3?: any;
  p4?: any;
}
export interface BiError {
  id: string;
  name: string;
}
export function biErrorLoggerFactory({compId, sessionId, playerVersion, artifactVersion, albumId}) {
  const defaultErrorParams = {
    src: 9,
    evid: 10,
    compId,
    sessionId,
    playerVersion,
    artifactVersion,
    p1: albumId,

    cat: 1,
    iss: 7,
    sev: 10,
  };
  const errorLogger = iframeAppBiLoggerFactory(Wix, {endpoint: 'trg'}).updateDefaults(defaultErrorParams).logger();

  return {
    createLoggingCatcher(biEvent) {
      return (reason) => {
        this.logError(biEvent, reason);
        return Promise.reject(reason);
      };
    },
    logError(event, p2?, p3?, p4?) {
      const eventParams: ErrorEventParams = {
        errc: event.id,
        errn: event.name,
      };
      if (p2) {
        if (p2 instanceof Error) {
          p2 = p2.message;
        }
        eventParams.p2 = p2;
      }
      if (p3) {
        eventParams.p3 = p3;
      }
      if (p4) {
        eventParams.p4 = p4;
      }
      return errorLogger.log(eventParams);
    },
  };
}
